module.exports = __webpack_public_path__ + "img/15.4a750605.jpg";